import { SVGProps } from 'react';

const SvgNotes = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 33 32" {...props}>
    <path
      stroke="#FF8F44"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.667 9.333h8m-8 5.334h8m-8 5.333H18M7.333 6.667A2.667 2.667 0 0 1 10 4h13.333A2.667 2.667 0 0 1 26 6.667v18.666A2.667 2.667 0 0 1 23.333 28H10a2.667 2.667 0 0 1-2.667-2.667z"
    />
  </svg>
);
export default SvgNotes;
